import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider, useDispatch } from "react-redux";
import App from "./App";
import "./index.css";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";
import i18n, { initializeI18n } from "./i18n";
import { setInitialLanguage } from "./redux/slices/language.slice";
import { I18nextProvider, initReactI18next } from "react-i18next"; // ✅ ADD THIS

const LanguageInitializer = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchLanguage = async () => {
      const userLanguage = await initializeI18n();
      dispatch(setInitialLanguage(userLanguage));
    };

    fetchLanguage();
  }, [dispatch]);

  return null; // No rendering visible, update only state
};

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const startApp = async () => {
  // await initializeI18n();
  // Init with default EN to unblock rendering
  await i18n.use(initReactI18next).init({
    resources: {
      en: { translation: {} }, // Empty or static fallback
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: { escapeValue: false },
  });
  root.render(
    <React.StrictMode>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <App />
        </Provider>
      </I18nextProvider>
    </React.StrictMode>
  );
};

// root.render(
//   <Provider store={store}>
//     <I18nextProvider i18n={i18n}>
//       {" "}
//       {/* ✅ WRAP HERE */}
//       {/* <LanguageInitializer /> */}
//       <App />
//     </I18nextProvider>{" "}
//     {/* ✅ CLOSE HERE */}
//   </Provider>
// );

startApp();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
